// Deep-link builders for external reservation providers.
// All providers accept public search params — no auth/API needed.
// User completes the booking on the provider site, then records the
// confirmation number in The Common Dinner.

const enc = encodeURIComponent;

export function openTableUrl({ name, city, date, time, party }) {
  // OpenTable search: term=<name>, dateTime=YYYY-MM-DDTHH:MM, covers=<N>
  const params = new URLSearchParams();
  if (name) params.set("term", city ? `${name} ${city}` : name);
  if (date && time) params.set("dateTime", `${date}T${time}`);
  if (party) params.set("covers", String(party));
  return `https://www.opentable.com/s?${params.toString()}`;
}

export function resyUrl({ name, city, date, party }) {
  // Resy's home search accepts ?query=<name>. Date/seats are picked
  // on the venue page after the user clicks the result.
  const q = [name, city].filter(Boolean).join(" ");
  const params = new URLSearchParams();
  if (q) params.set("query", q);
  if (date) params.set("date", date);
  if (party) params.set("seats", String(party));
  return `https://resy.com/?${params.toString()}`;
}

export const PROVIDERS = [
  { id: "opentable", label: "OpenTable", build: openTableUrl },
  { id: "resy",      label: "Resy",      build: resyUrl },
];

export function buildProviderUrl(providerId, ctx) {
  const p = PROVIDERS.find(x => x.id === providerId);
  return p ? p.build(ctx) : null;
}
